<template>
    <ThePage>
        <div class="card mb-3 d-none d-sm-block">
            <div class="card-body card-body-search">
                <input :value="filter.search" type="text" class="form-control form-control-search" placeholder="Быстрый поиск" @input="search">
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th v-sort:id>#</th>
                            <th v-sort:company_id>Компания</th>  <!-- class="w-25" -->
                            <td v-sort:vm_id>ТА</td>
                            <th v-sort:imei>IMEI</th>
                            <th v-sort:state>Состояние</th>
                            <th v-sort:iccid>ICCID</th>
                            <th v-sort:hardware_version>HW</th>
                            <th v-sort:firmware_version>Firmware</th>
                            <th v-sort:boot_version>Boot</th>
                            <th>Команды</th>
                            <th>Логи</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="modem in modems" :key="modem.id">
                            <td>{{ modem.id }}</td>
                            <td>
                                <router-link :to="{ name: 'admin.company', params: { id: modem.company_id }}">{{ modem.company_name }}</router-link>
                            </td>
                            <td v-na>
                                <span v-if="modem.vm_id">T{{ modem.vm_id }}</span>
                            </td>
                            <td v-na>{{ modem.imei }}</td>
                            <td v-na>
                                <modem-state-badge :state="modem.state" />
                            </td>
                            <td v-na>{{ modem.iccid }}</td>
                            <td v-na>{{ modem.hardware_version }}</td>
                            <td v-na>{{ modem.firmware_version | semver }}</td>
                            <td v-na>{{ modem.boot_version | semver }}</td>

                            <td>
                                <router-link :to="{ name: 'admin.modems.commands', params: { id: modem.id } }" class="btn btn-link p-0">
                                    <span v-if="modem.commands.length" class="badge badge-light">{{ modem.commands.length }} шт.</span>
                                    <i v-else class="tlm-icon-plus" />
                                </router-link>
                            </td>

                            <td v-na>
                                <a v-if="modem.imei" :href="`logs/${modem.imei}/${modem.imei}.log` | makeApiUrl" target="_blank" class="text-decoration-none">📄</a>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="modems.length === 0" class="no-one">
                        <tr>
                            <td colspan="42">Модемы не найдены.</td>
                        </tr>
                    </tfoot>
                </table>

                <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
                    <span />
                    <pagination v-show="meta && meta.last_page > 1" :meta="meta" class="pagination" @input="applyFilter({ page: $event })" />
                </div>
            </div>
        </div>

        <router-view />
    </ThePage>
</template>

<script>
import store from '@/store'
import adminStoreModule from '@/store/modules/admin'

import debounce from 'lodash/debounce'

import Pagination from '@/components/Pagination'
import ThePage from '@/components/ThePage'
import ModemStateBadge from '@/components/ModemStateBadge'

if (!store.state['admin']) {
    store.registerModule('admin', adminStoreModule)
}

export default {
    components: {
        ThePage,
        Pagination,
        ModemStateBadge
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        modems() {
            return store.state.admin.modems.data || []
        },

        meta() {
            return store.state.admin.modems.meta || {}
        }
    },

    methods: {
        search: debounce(function (e) {
            this.applyFilter({ page: 1, search: e.target.value })
        }, 750)
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('admin/modems/fetchAll', to.query)

        next()
    },

    async beforeRouteUpdate(to, from, next) {
        if (to.name === 'admin.modems.commands') {
            return next()
        }

        await store.dispatch('admin/modems/fetchAll', to.query)

        next()
    }
}
</script>
